import { render, staticRenderFns } from "./viewUsagerating.vue?vue&type=template&id=2f7fc68a"
import script from "./viewUsagerating.vue?vue&type=script&lang=js"
export * from "./viewUsagerating.vue?vue&type=script&lang=js"
import style0 from "./viewUsagerating.vue?vue&type=style&index=0&id=2f7fc68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports